module.exports = __webpack_public_path__ + "img/3_newYouth_dzb.5fd0b572.png";